module.exports = __webpack_public_path__ + "img/logo-128.427f5849.png";